// Copyright (c) 2018 Comsearch, Inc., All rights reserved

export const PATH_REPORT_EXPORT = 'path-report-export'
